import { computed } from "vue";
import { EBadgePlacement } from "../types.js";
import { EBadgeElements } from "../types.js";
import useCreateComponentConfig, { EStates, EVariants } from "../../../composables/useCreateComponentConfig.js";
import { SIZES } from "@/ui/ts/types/Sizes";
export function useBadgeConfig(props) {
  const { setBase, addSize, setDefault, getClasses, addVariant } = useCreateComponentConfig();
  const corner = props.placement === EBadgePlacement.CORNER;
  setBase(
    EBadgeElements.ROOT,
    /* tw */
    `border-radius-container-xs rounded-control flex w-fit max-w-full items-center justify-center uppercase 
        transition-all delay-0 duration-200 ease-linear ${corner && "mr-4 w-auto"}`
  );
  addSize(
    EBadgeElements.ROOT,
    SIZES.XSMALL,
    /* tw */
    `px-2xs h-5 gap-2xs label-xs ${corner && "px-xs rounded-br-container-md"}`
  );
  addSize(
    EBadgeElements.ROOT,
    SIZES.SMALL,
    /* tw */
    `px-xs h-6 gap-2xs label-xs ${corner && "px-sm rounded-br-container-md"}`
  );
  addSize(
    EBadgeElements.ROOT,
    SIZES.MEDIUM,
    /* tw */
    `px-xs h-7 gap-2xs label-sm ${corner && "px-sm rounded-br-container-lg"}`
  );
  addSize(
    EBadgeElements.ROOT,
    SIZES.LARGE,
    /* tw */
    `px-sm h-8 gap-horizontal-icon-to-element label-md ${corner && "px-base rounded-br-container-lg"}`
  );
  addVariant(EBadgeElements.ROOT, EVariants.HIGHLIGHT, {
    base: "",
    states: { [EStates.DEFAULT]: (
      /* tw */
      "bg-brand-highlight text-comp-high-contrast-on-dark"
    ) }
  });
  addVariant(EBadgeElements.ROOT, EVariants.ACCENT, {
    base: "",
    states: { [EStates.DEFAULT]: (
      /* tw */
      "text-comp-high-contrast-on-light bg-brand-accent"
    ) }
  });
  addVariant(EBadgeElements.ROOT, EVariants.PRIMARY, {
    base: "",
    states: { [EStates.DEFAULT]: (
      /* tw */
      "text-brand-accent bg-neutral-primary-invert"
    ) }
  });
  addVariant(EBadgeElements.ROOT, EVariants.SECONDARY, {
    base: "",
    states: { [EStates.DEFAULT]: (
      /* tw */
      "text-comp-high-contrast bg-neutral-tertiary"
    ) }
  });
  setDefault(EBadgeElements.ROOT, EVariants.PRIMARY, SIZES.MEDIUM);
  const rootClasses = computed(() => {
    return getClasses(EBadgeElements.ROOT, props.variant, props.size, EStates.DEFAULT);
  });
  return {
    rootClasses: rootClasses.value
  };
}
